var _line, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconArrowBack = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  className: "icon icon--arrow-back",
  width: 24,
  height: 24,
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  ref: svgRef
}, props), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 19,
  y1: 12,
  x2: 5,
  y2: 12
})), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
  points: "12 19 5 12 12 5"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconArrowBack, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconArrowBack.13f5f4a8.svg";
export { ForwardRef as ReactComponent };